import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';

const Pagination = ({ onChange, pageItems, list }) => {
  const [page, setPage] = useState(1);
  const lastPage = Math.ceil(list.length / pageItems);

  const reset = () => {
    setPage(1);
    onChange(1);
  };
  const finish = () => {
    setPage(lastPage);
    onChange(lastPage);
  };
  const onNext = () => {
    setPage(page + 1);
    onChange(page + 1);
  };
  const onBack = () => {
    setPage(page - 1);
    onChange(page - 1);
  };

  useEffect(() => {
    setPage(1);
  }, [list]);

  return (
    <div className='m-auto d-flex justify-content-center col-12 gap-2'>
      <button
        className={`page-link text-danger ${page === 1 ? 'text-opacity-50' : ''}`}
        style={{ color: '#E4002B' }}
        onClick={reset}
        disabled={page === 1}
      >
        <FontAwesomeIcon icon={faChevronLeft} />
        <FontAwesomeIcon icon={faChevronLeft} />
      </button>
      <button
        className={`page-link text-danger ${page === 1 ? 'text-opacity-50' : ''}`}
        style={{ color: '#E4002B' }}
        onClick={onBack}
        disabled={page === 1}
      >
        <FontAwesomeIcon icon={faChevronLeft} />
      </button>
      <span className='p-2'>
        <strong>{page}</strong> de {Math.ceil(list.length / pageItems)}
      </span>
      <button
        className={`page-link text-danger ${page === lastPage ? 'text-opacity-50' : ''}`}
        style={{ color: '#E4002B' }}
        onClick={onNext}
        disabled={page === lastPage}
      >
        <FontAwesomeIcon icon={faChevronRight} />
      </button>
      <button
        className={`page-link text-danger ${page === lastPage ? 'text-opacity-50' : ''}`}
        style={{ color: '#E4002B' }}
        onClick={finish}
        disabled={page === lastPage}
      >
        <FontAwesomeIcon icon={faChevronRight} />
        <FontAwesomeIcon icon={faChevronRight} />
      </button>
    </div>
  );
};

export default Pagination;
